import {Button} from "@blueprintjs/core";
import React, {ReactNode, useEffect, useMemo, useState} from "react";
import {useFilePicker} from "use-file-picker";
import {IconName} from "@blueprintjs/icons";
import type {MaybeElement} from "@blueprintjs/core";

export const FilePicker: React.FC<{

  accept: string;
  children?: ReactNode;
  onPick?: (file: File) => void;
  icon?: IconName | MaybeElement;

}> = ({accept, children, onPick, icon}) => {

  const [picked, setPicked] = useState<boolean>(false);

  const [openFileSelector, {filesContent, loading /*, errors */}] = useFilePicker({
    accept,
    readAs:   'ArrayBuffer',
    multiple: false,
  });

  const file: File | null = useMemo(() => {
    return filesContent.length ? new File(
      [filesContent[0].content],
      filesContent[0].name,
    ) : null;
  }, [filesContent]);

  useEffect(() => {
    if (file && !picked) {
      onPick?.(file);
      setPicked(true);
    }
  }, [onPick, file, picked, setPicked]);

  return <Button
    intent={'primary'}
    disabled={picked}
    loading={loading}
    onClick={openFileSelector}
    icon={icon}
  >
    {children}
  </Button>;
};